import type { SVGProps } from 'react'

export const CheckInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    role="img"
    aria-label="Check in circle"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#358730"
        d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m-.482 10.365L4.852 7.698l.96-.961 1.706 1.705 2.82-2.819.96.962z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
